import type { FC } from 'react';
import { memo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { ReactComponent as MessagesIcon } from '../../icons/icon-messages.inline.svg';
import { useAppSelector } from '../../redux/hooks';
import type { MessageId } from './thread-slice';
import { getStateMsg } from './thread-slice-utils';

const intlMessages = defineMessages({
  replies: {
    defaultMessage: `{count, plural,
    =0 {{count} réponse}
    =1 {{count} réponse}
    other {{count} réponses}
  }`,
    id: 'TAlT0d',
  },
});

interface ThreadNbResponsesProps {
  parentMessageId: MessageId | undefined;
}

export const ThreadNbResponses: FC<ThreadNbResponsesProps> = memo(function ThreadNbResponses(
  props,
) {
  const { parentMessageId } = props;

  const childMessagesLengthDisplayed = useAppSelector(s => {
    const msg = getStateMsg(s, parentMessageId);
    return msg?.childMessagesCount || msg?.childMessagesIds?.length || 0;
  });

  if (childMessagesLengthDisplayed === 0) return null;

  return (
    <div className="ThreadMessageAnswersDepthCounter flex justify-center items-center space-x-2 text-sm2">
      <MessagesIcon className="w-4 h-4" />
      <span className="md:hidden">{childMessagesLengthDisplayed}</span>
      <span className="hidden md:flex">
        <FormattedMessage
          {...intlMessages.replies}
          values={{ count: childMessagesLengthDisplayed }}
        />
      </span>
    </div>
  );
});
